import { render, staticRenderFns } from "./promoterList.vue?vue&type=template&id=1ba4daa8&scoped=true&"
import script from "./promoterList.vue?vue&type=script&lang=js&"
export * from "./promoterList.vue?vue&type=script&lang=js&"
import style0 from "./promoterList.vue?vue&type=style&index=0&id=1ba4daa8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba4daa8",
  null
  
)

export default component.exports